import styled from "styled-components";

export const TituloComIcone = styled.span`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const IconeCirculo = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #f97316;
  color: #fff;
  font-size: 0.65rem;
  flex-shrink: 0;
  box-shadow: 0 0 0 5px rgba(249, 115, 22, 0.2);
`;

export const TextoDescricao = styled.p`
  margin: 0 0 24px 0;
  font-size: 0.9rem;
  color: ${({ theme }) => theme.colors.neutral.neutral80};
`;

export const ObservacaoContainer = styled.div`
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 16px;
`;

export const ErroTexto = styled.span`
  color: #ee5353;
  font-size: 0.8rem;
`;
